import React from 'react';
import '../../styles/AIFooter.css';

const AIFooter = () => {
  return (
    <footer className="ai-footer">
      <div className="ai-footer-content">
        <div className="ai-footer-links">
          <a
            href="/legal#ai"
            target="_blank"
            rel="noopener noreferrer"
            className="ai-footer-link"
          >
            AI Use Policy
          </a>
        </div>
        <div className="ai-disclaimer">
          <p>
            <i className="ri-information-line"></i>
            AI-generated content may contain inaccuracies. Please manually review and verify all survey questions before publishing.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default AIFooter;
